import React,{ useState, useEffect } from 'react'
import slide_1 from '../Assets/no_bg/logo.png'
import slide_2 from '../Assets/no_bg/yellow.png'
import slide_3 from '../Assets/no_bg/purple.png'
import slide_4 from '../Assets/no_bg/red.png'
import slide_5 from '../Assets/no_bg/blue.png'
import { motion } from 'framer-motion'
import { fadeIn, staggerContainer } from '../utils/motion'
import { Link } from 'react-router-dom'
import { Search } from '@mui/icons-material'
import { Slide, Products } from './'

const Home = ({ setCartItems, buttonAction, products, setProducts }) => {
 const slides = [slide_1, slide_2, slide_3, slide_4, slide_5]

 const [currentIndex, setCurrentIndex] = useState(0)
 useEffect(()=>{
   const interval = setInterval(() =>{
    setCurrentIndex((prev)=>(prev + 1) % slides.length)
 },4000)
 return () => clearInterval(interval)
})
 const colors = ['green', 'orange', 'purple', 'red', 'blue']

  return (
    <div className=''>
      <div className='bg-primary h-[50vh] p-5 flex flex-col justify-center items-center'>
      <div style={{ border:'solid 1px gray' }} className='flex justify-between items-center'>
            <input  className='p-3 md:w-[50vw] border-none' placeholder='Search items'/>
            <div className='bg-gray-200 p-3 cursor-pointer'>
                <Search/>
            </div>
      </div>
      </div>
    {/* <Slide/> */}
    <Products setProducts={setProducts} buttonAction={buttonAction} products={products}/>
    </div>
  )
}

export default Home


























// import { useState, useEffect } from "react";
// import { motion } from "framer-motion";

// const slides = ["Slide 1", "Slide 2", "Slide 3", "Slide 4"];

// export default function Home() {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((prev) => (prev + 1) % slides.length);
//     }, 4000); // 2s transition + 2s pause

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="relative w-[300px] h-[200px] overflow-hidden bg-gray-200 flex items-center justify-center">
//       {slides.map((slide, index) => (
//         <motion.div
//           key={index}
//           className="absolute w-full h-full flex items-center justify-center text-2xl font-bold bg-blue-500 text-white"
//           initial={{ x: "100%", opacity: 0 }} // Start off-screen right
//           animate={index === currentIndex ? { x: 0, opacity: 1 } : { x: "-100%", opacity: 0 }} // Move in while fading
//           transition={{ duration: 2, ease: "easeInOut" }} // Smooth slide-in & fade-in
//         >
//           {slide}
//         </motion.div>
//       ))}
//     </div>
//   );
// }
